import { Component, Inject, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle
} from '@angular/material/dialog';

type ConfirmationDialogData = {
    title: string;
    message: string;
    confirm: string;
    cancel: string;
    subMessage?: string;
};

@Component({
    selector: 'lib-confirmation-dialog',
    imports: [
        MatButtonModule,
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions
    ],
    templateUrl: './confirmation-dialog.component.html',
    styleUrl: './confirmation-dialog.component.scss'
})
export class ConfirmationDialogComponent {
    private dialogRef = inject(MatDialogRef<ConfirmationDialogComponent>);

    constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData) {}

    handleOnClick = (confirmed: boolean) => {
        this.dialogRef.close(confirmed);
    };
}